<template>
  <div>
    <table
        class="machine-inventory__table table-striped table-bordered"
        :class="{ print: prepareForPrint }"
    >
      <thead>
      <tr>
        <td colspan="2" class="text-center bg-secondary text-light">
          <div>
            <label class="mt-2">Inventário</label>
            <button
              v-if="!prepareForPrint && authenticated_user !== 'Cliente somente leitura'"
              @click="toggleEditable"
              class="btn btn-primary m-1 float-right"
            >
              {{ editable ? 'Salvar' : 'Editar' }}
            </button>
          </div>
        </td>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>Capacidade</td>
        <td>
          <select @change="changeCapacity($event)" :class="{ 'not-selectable': !editable }" :disabled="!editable">
            <option v-for="capacity in capacities"
                    :selected="capacity === machine?.capacity"
                    :value="capacity"
            >{{ capacity }}
            </option>
          </select>
        </td>
      </tr>
      <tr>
        <td>Tensão</td>
        <td>
          <select @change="changeVoltage($event)" :class="{ 'not-selectable': !editable }" :disabled="!editable">
            <option v-for="voltage in voltages"
                    :selected="voltage === machine?.voltage?.name"
                    :value="voltage"
            >{{ voltage }}v
            </option>
          </select>
        </td>
      </tr>
      <tr>
        <td>Aterramento</td>
        <td>
          <select @change="changeGroundWire($event)" :class="{ 'not-selectable': !editable }" :disabled="!editable">
            <option :selected="machine?.has_ground_wire" value="Sim">SIM</option>
            <option :selected="!machine?.has_ground_wire" value="Nao">NÃO</option>
          </select>
        </td>
      </tr>
      <tr v-for="safetySystem in safetySystems" :key="safetySystem.id">
        <td>{{ safetySystem.name }}</td>
        <td>
          <select @change="changeSafetySystem(safetySystem, $event)" :class="{ 'not-selectable': !editable }" :disabled="!editable">
            <option :selected="safetySistemValue(safetySystem) == 'Sim'" value="Sim">SIM</option>
            <option :selected="safetySistemValue(safetySystem) == 'Não'" value="Não">NÃO</option>
            <option :selected="safetySistemValue(safetySystem) == 'N/A'" value="N/A">N/A</option>
            <option :selected="safetySistemValue(safetySystem) == 'I/C'" value="I/C">I/C</option>
          </select>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "axios";
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
  props: {
    safetySystems: {
      type: Array,
      required: false,
      default: () => [],
    },
    machine: {
      type: Object,
      required: true,
    },
    prepareForPrint: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    const store = useStore()

    const authenticated_user = computed(() => store.getters.authenticated_user.user_profile.name)

    return {
      voltages: ['110', '220', '380', '440'],
      capacities: ['SOB DEMANDA', 'NAO SOUBE INFORMAR'],
      editable: false,
      authenticated_user
    }
  },
  methods: {
    safetySistemValue(safetySystem) {
        const machineSafetySystem = this?.machine?.safety_systems.filter(mms => mms.id === safetySystem.id)[0]
        return machineSafetySystem.pivot.status
    },
    changeSafetySystem(safetySystem, event) {
      const value = event.target.value

      const data = {
        machine_id: this.machine.id,
        safety_system_id: safetySystem.id,
        value
      }

      axios.post('/api/safety_systems/update', data);
    },
    changeGroundWire(event) {
      const data = {
        machine_id: this.machine.id,
      }

      if (event.target.value === 'Sim') {
        axios.post('/api/ground_wire/enable', data);
      } else {
        axios.post('/api/ground_wire/disable', data);
      }
    },
    changeVoltage(event) {
      const data = {
        machine_id: this.machine.id,
        voltage: event.target.value
      }

      axios.post('/api/machines/voltage', data);
    },
    changeCapacity(event) {
      const data = {
        machine_id: this.machine.id,
        capacity: event.target.value
      }

      axios.post('/api/machines/capacity', data);
    },
    toggleEditable(event) {
      event.preventDefault()
      this.editable = !this.editable
    },
  },
}
</script>

<style lang="scss" scoped>
  .machine-inventory {
    &__table {
      width: 100%;

      &.print {
        font-size: 0.7rem;
      }
    }
  }

  .not-selectable {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none; 
    border: none;
    overflow:hidden;
    background: rgba(0, 0, 0, 0);
    width: 80%;
  }

  select:disabled {
    color: black;
  }

  @media print {
    select {
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none; 
      border: none;
      overflow:hidden;
      background: rgba(0, 0, 0, 0);
      width: 80%;
    }
  }
</style>
